import React, { useEffect, useState } from "react";
import "../../../styles/desktop/dispositivo.css";


import fetchDispositivos from "../../../API/basic/getDispositivos";

export default function Dispositivos() {
    const [dispositivos, setDispositivos] = useState([]);
    const [error, setError] = useState(false); // Para rastrear erros de requisição
    const [loading, setLoading] = useState(true); // Para exibir estado de carregamento

    useEffect(() => {
        const getData = async () => {
            try {
                setLoading(true);
                setError(false);
                const data = await fetchDispositivos();
                if (data) {
                    setDispositivos(data); // Define dispositivos, mesmo se vazio
                } else {
                    setDispositivos([]); // Nenhum dispositivo registrado
                }
            } catch (err) {
                console.error("Erro ao buscar dispositivos:", err);
                setError(true); // Define erro caso a requisição falhe
                setLoading(false);
            } finally {
                setLoading(false);
            }
        };

        getData();
        const interval = setInterval(getData, 50000);
        return () => clearInterval(interval);
    }, []);

    // Função para agrupar dispositivos por tipo
    const agruparPorTipo = (dispositivos) => {
        return dispositivos.reduce((grupos, dispositivo) => {
            const tipo = dispositivo.tipo || "Desconhecido"; // Define um tipo padrão
            if (!grupos[tipo]) grupos[tipo] = [];
            grupos[tipo].push(dispositivo);
            return grupos;
        }, {});
    };

    const dispositivosPorTipo = agruparPorTipo(dispositivos);

    // Animação de carregamento
    if (loading) {
        return (
            <div className="dispositivosContainer">
                <div className="loading-animation">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        );
    }

    // Mensagem de erro
    if (error) {
        return (
            <div className="dispositivosContainer">
                <p className="dispositivosMsgErro">Ocorreu um erro com a comunicação com o Servidor</p>
            </div>
        );
    }

    // Mensagem quando não há dispositivos, mas a requisição foi bem-sucedida
    if (!error && dispositivos.length === 0) {
        return (
            <div className="dispositivosContainer">
                <p className="dispositivosMsgErro">Nenhum dispositivo registrado</p>
            </div>
        );
    }

    // Renderização dos dispositivos agrupados por tipo
    return (
        <div className="dispositivosContainer">
            {Object.entries(dispositivosPorTipo).map(([tipo, dispositivos]) => (
                <div key={tipo} className="dispositivosGrupo">
                    <h2>{tipo}</h2>
                    <div className="dispositivosCentral">
                        {dispositivos.map((dispositivo, index) => (
                            <div key={index} className="dispositivosModal">
                                <h3>{dispositivo.nome}</h3>
                                <h4>{dispositivo.ip}</h4>
                                <p>Tipo: {dispositivo.tipo}</p>
                                <p
                                    className={
                                        dispositivo.status ? "ativo" : "inativo"
                                    }
                                >
                                    Status: {dispositivo.status
                                        ? "Ativo"
                                        : "Inativo"}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
